import { APIConfig } from 'reactApp/api/APIConfig';

export const withToken = (url: string | undefined): string | undefined => {
    const token = APIConfig.get('workspace-superapp-access-token');
    if (!url || !token) {
        return url;
    }

    let withTokenUrl: URL | null = null;
    try {
        withTokenUrl = new URL(url);
    } catch {
        return url;
    }

    if (!withTokenUrl.searchParams.get('token')) {
        withTokenUrl.searchParams.set('token', token);
    }

    return withTokenUrl.toString();
};
